import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { addUserPhoneLogEntry } from 'flow/utils/browser-utils';
import { getPendingTransferNumber, getPendingTransferStartTime } from 'flow/selectors/call-selectors';
import { getContactDataForNumber } from 'flow/selectors/contact-selectors';
import { lookupNumber } from 'flow/actions/contact-actions';
import { cancelAttendedTransfer, completeAttendedTransfer } from 'flow/actions/phone-actions';
import SmallCallItem from './SmallCallItem';
import LargeCallItem from './LargeCallItem';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var PendingAttendedTransferCallItems = function PendingAttendedTransferCallItems(_ref) {
  var itemSize = _ref.itemSize,
    displayMode = _ref.displayMode,
    direction = _ref.direction,
    contact = _ref.contact,
    remoteNumber = _ref.remoteNumber,
    ownCountryCode = _ref.ownCountryCode;
  var dispatch = useAppDispatch();
  var transferNumber = useAppSelector(getPendingTransferNumber);
  var transferContact = useAppSelector(function (state) {
    return (
      //@ts-ignore
      getContactDataForNumber(state, transferNumber)
    );
  });
  var transferStartTime = useAppSelector(getPendingTransferStartTime);
  useEffect(function () {
    if (transferNumber && !transferContact) {
      addUserPhoneLogEntry("Doing numberlookup on ".concat(transferNumber));
      dispatch(lookupNumber(transferNumber));
    }
  }, [transferNumber, transferContact]);
  useEffect(function () {
    addUserPhoneLogEntry("Attended transfer call items mounted, held: ".concat(remoteNumber, " active: ").concat(transferNumber));
    return function () {
      addUserPhoneLogEntry('Attended transfer call items unmounted');
    };
  }, [remoteNumber, transferNumber]);
  var transferTargetProps = {
    direction: 'outgoing',
    remoteNumber: transferNumber,
    contact: transferContact,
    startTime: transferStartTime,
    onTransferCancel: function onTransferCancel() {
      return dispatch(cancelAttendedTransfer());
    },
    onTransferComplete: function onTransferComplete() {
      return dispatch(completeAttendedTransfer());
    },
    displayMode: displayMode,
    ownCountryCode: ownCountryCode,
    isEnded: false,
    isAccepted: true,
    isOnHold: false
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SmallCallItem, {
      isAwaitingTransfer: true,
      direction: direction,
      contact: contact,
      remoteNumber: remoteNumber,
      isOnHold: true,
      ownCountryCode: ownCountryCode,
      isEnded: false,
      isAccepted: true
    }), itemSize === 'large' ? /*#__PURE__*/_jsx(LargeCallItem, _objectSpread({}, transferTargetProps)) : /*#__PURE__*/_jsx(SmallCallItem, _objectSpread({}, transferTargetProps))]
  });
};
export default PendingAttendedTransferCallItems;